import script from './SdsTypeSwitcher.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"type-switcher"},_vm._l((_vm.types),function(type){return _c('SdsButton',{key:type.type,attrs:{"isDisabled":type.disabled,"variant":_vm.selected === type.type ? 'primary' : 'secondary',"size":"md"},on:{"click":function($event){return _vm.onClick(type)}}},[(type.icon)?_c('SdsIcon',{attrs:{"iconName":type.icon}}):_vm._e(),_vm._v(" "),_vm._t("default",function(){return [_vm._v("\n            "+_vm._s(type.displayName)+"\n        ")]},{"displayName":type.displayName}),_vm._v(" "),(type.size !== undefined)?_c('span',{staticClass:"type-switcher__counter"},[_vm._v("\n            "+_vm._s(type.size)+"\n        ")]):_vm._e()],2)}),1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-59c4d218_0", { source: ".type-switcher[data-v-59c4d218]{display:flex;justify-content:center;gap:var(--space-between-cards-sm)}.type-switcher .sds-button[data-v-59c4d218]{width:100%}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-59c4d218";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
